import type { ShiftRecord } from '@libs/data-access/queries'
import { Modal } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

type Props = {
  shift: ShiftRecord
  shiftIsLocked: boolean
  canValidate: boolean
  deleteCta: () => void
  isLoading: boolean
  isManager: boolean
  disabled?: boolean
}

/**
 * @deprecated file
 */

export const ModalActionFooterLegacy: FC<Props> = ({
  shift,
  shiftIsLocked,
  canValidate,
  deleteCta,
  isLoading,
  isManager,
  disabled = false
}) => {
  const { t } = useCommonAppTranslation()

  if (shiftIsLocked) {
    return null
  }

  return (
    <Modal.Footer className='sticky bottom-0 bg-neutral-50 pt-6'>
      {shift && shift.id && isManager && (
        <Modal.Footer.Danger
          loading={isLoading}
          onClick={deleteCta}
          variant='secondary'
          fillWidth
          disabled={disabled}
        >
          {t('action.delete')}
        </Modal.Footer.Danger>
      )}

      <Modal.Footer.Success
        loading={isLoading}
        type='submit'
        variant='primary'
        intent='default'
        fillWidth
        disabled={disabled}
      >
        {canValidate ? t('action.validate') : t('action.register')}
      </Modal.Footer.Success>
    </Modal.Footer>
  )
}
